import { ScrollCarousel } from './theme.js';

class CustomCarousel extends ScrollCarousel {
  constructor() {
    super();
    this.autoplayTimeout = null;
    this.isPaused = false;
    this.lastManualScrollTime = 0;
  }

  connectedCallback() {
    super.connectedCallback();
    this.setupAutoplay();
    
    this.addEventListener('scroll', () => {
      if (!this.isAutoScrolling) {
        this.lastManualScrollTime = Date.now();
      }
    }, { passive: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.stopAutoplay();
  }

  setupAutoplay() {
    if (this.hasAttribute("autoplay") && this.cells.length > 1) {
      const duration = parseInt(this.getAttribute("autoplay")) || 5;
      this.autoplayDuration = duration * 1000;
      
      this.startAutoplay(this.autoplayDuration);

      if (this.hasAttribute("pause-on-hover")) {
        this.addEventListener("mouseenter", () => this.pauseAutoplay());
        this.addEventListener("mouseleave", () => this.resumeAutoplay());
      }

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener("shopify:block:select", () => this.stopAutoplay());
        this.addEventListener("shopify:block:deselect", () => {
          this.isPaused = false;
          this.startAutoplay(this.autoplayDuration);
        });
      }
    }
  }

  startAutoplay(interval) {
    this.stopAutoplay();
    this.autoplayTimeout = setInterval(() => {
      if (!this.isPaused) {
        const timeSinceLastScroll = Date.now() - this.lastManualScrollTime;
        if (timeSinceLastScroll < this.autoplayDuration) {
          return;
        }

        const isAtEnd = Math.abs(this.scrollLeft - (this.scrollWidth - this.clientWidth)) < 10;
        
        this.isAutoScrolling = true;
        if (isAtEnd) {
          this.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollBy({ left: this.clientWidth * 0.9, behavior: 'smooth' });
        }
        
        setTimeout(() => {
          this.isAutoScrolling = false;
        }, 500);
      }
    }, interval);
  }

  stopAutoplay() {
    if (this.autoplayTimeout) {
      clearInterval(this.autoplayTimeout);
      this.autoplayTimeout = null;
    }
  }

  pauseAutoplay() {
    this.isPaused = true;
  }

  resumeAutoplay() {
    this.isPaused = false;
  }
}

if (!window.customElements.get("custom-carousel")) {
  window.customElements.define("custom-carousel", CustomCarousel);
}

